<template>
<div class="chapter">
<div class="inner_page">
<h1 class="halftitle">The Little Lark Still Sings</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?4e12343a